<template>
  <button
    @click="$emit('click')"
    type="button"
    class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150"
  >
    <font-awesome-icon
      v-if="icon"
      :icon="icon"
      class="fa-fw nav-icon mr-1"
    ></font-awesome-icon>
    <slot></slot>
  </button>
</template>
<script>
export default {
  name: "BaseButtonPrimarySmall",
  props: ["icon"],
};
</script>
